/**
 * If the event id is one of our number_number strings, this will get the first part of the id
 * @param rawId
 * @returns
 */
export const getCalendarEventItemId = (rawId: string | number) => {
  const id =
    typeof rawId === 'string'
      ? rawId.indexOf('_') > -1
        ? parseInt(rawId.split('_')[0])
        : parseInt(rawId)
      : rawId;
  return id;
};
